import { render, staticRenderFns } from "./ReviewsFullListController.vue?vue&type=template&id=39723a70&scoped=true&"
import script from "./ReviewsFullListController.vue?vue&type=script&lang=ts&"
export * from "./ReviewsFullListController.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewsFullListController.vue?vue&type=style&index=0&id=39723a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39723a70",
  null
  
)

export default component.exports